/* eslint-disable array-callback-return */
/* eslint-disable consistent-return */
import React from 'react';
import { Utils } from 'Utils/utils';
import { observer } from 'mobx-react';
import userDetail from 'Stores/userDetail';
import companySearchState from 'Stores/companySearch';
import { CreateNewList } from 'Components/common/createNewList';
import { LoadingWrapper } from 'Components/common/loadingWrapper';
import { advSearchState } from 'Stores/advSearch';
import ExportCompanies, {
  exportCompaniesState,
} from 'Components/common/exportCompanies/exportCompanies';
import Pagination from 'Components/common/pagination';
import { confirmationPopupState } from 'Components/common/confirmationPopup';
import { withRouter } from 'react-router-dom';
import { ReactComponent as NewSearchImg } from 'Assets/svg/new-search-img.svg';
import { CONTACT_COUNT_IN_MILLIONS } from 'Utils/constants';
import { FIlterFacets } from './filterFacets/filterFacets';
import { AppliedFilters } from './appliedFilters';
import { CompanyList } from './searchList/companyList';
import { CreateSaveSearch } from './createSaveSearch';
import { SaveSearchComponent } from './saveSearch';
import noResultsContactIcon from '../../../assets/png/noResultsContact.png';
import noResultsCompanyIcon from '../../../assets/png/noResultsCompany.png';
import emptyFilterIcon from '../../../assets/png/emptyFilters.png';
import oneMoreCriteriaIcon from '../../../assets/png/oneMoreCriteria.png';
import { CompanyMiddleSection } from './companyMiddleSection';
import { contactFilterPopupState } from './filterFacets/contactFilterPopup';

const NoResultsFound = props => {
  const { currentTab } = props;
  // eslint-disable-next-line react/style-prop-object
  return (
    <div className="no-results-wrap">
      <NewSearchImg />
      <div className="no-results-text">
        We did not find{' '}
        <span>{currentTab === 'contact' ? 'contacts' : 'companies'}</span> that
        match your search criteria. <br /> Please revise your search criteria
      </div>
    </div>
  );
};

const ProvideOneMoreCriteria = () => {
  // eslint-disable-next-line react/style-prop-object
  return (
    <div className="no-results-wrap">
      <NewSearchImg />
      <div className="no-results-text">
        Please select at least one more search criteria
      </div>
    </div>
  );
};

const EmptySearchCriteria = props => {
  const { currentTab = 'contact' } = props;

  // eslint-disable-next-line react/style-prop-object
  return (
    <div className="no-results-wrap">
      <NewSearchImg />
      <div className="no-results-text">
        {currentTab === 'contact'
          ? `Provide your search criteria and find your contacts from over ${CONTACT_COUNT_IN_MILLIONS} business contacts`
          : 'Provide your search criteria to find companies'}
      </div>
    </div>
  );
};

const ResultSection = observer(props => {
  const { contactId, setContactId, currentTab = 'contact' } = props;

  let currentSelectedState;
  if (currentTab === 'contact') currentSelectedState = advSearchState;
  else currentSelectedState = companySearchState;

  if (!currentSelectedState.resultLoading) {
    if (currentSelectedState.resultStatusMsg === 'empty')
      return <EmptySearchCriteria currentTab={currentTab} />;
    if (currentSelectedState.resultStatusMsg === 'one_more')
      return <ProvideOneMoreCriteria currentTab={currentTab} />;
    if (currentSelectedState.searchResults.length > 0)
      return (
        <CompanyList
          data={currentSelectedState.searchResults}
          allChecked={currentSelectedState.allContactSelected}
          contactId={contactId}
          setContactId={setContactId}
          {...props}
        />
      );

    return <NoResultsFound currentTab={currentTab} />;
  }
  return '';
});

const currentTab = 'company';

const CompanySearchWrap = observer(props => {
  const [contactId, setContactId] = React.useState('');

  const { match } = props;
  const { params, path } = match;

  Utils.setLocalStorage('companySearch', true);

  userDetail.setCurrentTab(currentTab);

  const [templateName, setTemplateName] = React.useState('');
  const [savedSearchId, setSavedSearchId] = React.useState('');

  React.useEffect(() => {
    // After login check - flow
    console.log('onFirstLoad ', userDetail.onFirstLoad);
    if (userDetail.userInfo.userLoggedIn) companySearchState.retainSearch();
  }, [userDetail.onFirstLoad]);

  const hideSuggestionOnMouseLeave = e => {
    if (
      document &&
      document.querySelectorAll('.filter-parents .suggestion-mask').length > 0
    ) {
      document.querySelectorAll('.filter-parents .suggestion-mask')[0].click();
      document.activeElement.blur();
    }
  };

  const changePageLimit = val => {
    companySearchState.setPageLimit(val);
  };

  const changePage = (pageNo, opr) => {
    if (
      companySearchState.selectedAllContactAcrossPage ||
      companySearchState.selectedContactFromRange
    ) {
      const deselectCallback = () => {
        companySearchState.updateSelectedBulkContactAll(true);
      };
      confirmationPopupState.setPopupValues({
        title: 'Unable to deselect',
        content:
          'Unable to deselect individual items while using "Select all or Range selection". To deselect an item, clear the selection and select items individually.',
        actionBtnText: 'Clear selection',
        callback: deselectCallback,
      });
      confirmationPopupState.setShowPopup(true);
    } else {
      companySearchState.setCurrentPage(pageNo, opr);
    }
  };

  return (
    <div className="search-results company-search">
      <div className="left-section">
        <div className="page-title-text">Company Search</div>
        <SaveSearchComponent
          templateName={templateName}
          savedSearchId={savedSearchId}
          currentTab={currentTab}
        />
        <div
          className={`filter-container${
            currentTab === 'contact'
              ? ' contact-filter-container'
              : ' company-filter-container'
          }`}
          onMouseLeave={e => hideSuggestionOnMouseLeave(e)}
        >
          <FIlterFacets currentTab={currentTab} />
        </div>
      </div>
      <div className="right-section">
        <AppliedFilters currentTab={currentTab} />
        {companySearchState.searchResultCount > 0 && (
          <CompanyMiddleSection
            contactId={contactId}
            setContactId={setContactId}
            {...props}
          />
        )}
        <ResultSection
          currentTab={currentTab}
          contactId={contactId}
          setContactId={setContactId}
          {...props}
        />
        {companySearchState.resultLoading && (
          <CompanyList
            isListLoading
            data={[]}
            allChecked={false}
            contactId=""
            setContactId={setContactId}
          />
        )}
        {companySearchState.searchResultCount > 0 && (
          <Pagination
            totalCount={companySearchState.searchResultCount}
            rowsPerPage={companySearchState.pageLimit}
            currentPage={companySearchState.currentPage + 1}
            updateCurrentPage={changePage}
            onRowsPerPageUpdate={changePageLimit}
            pageName="advSearchCompany"
            showTotalLogs={false}
          />
        )}
      </div>
      <div
        className={`processing-exportCont${
          exportCompaniesState.showProcessingExport ? '' : ' hide'
        }`}
      >
        <p className="processing-export">
          Please wait, we&apos;re processing your export
        </p>
      </div>
      <CreateNewList />
      <CreateSaveSearch />
      <ExportCompanies />
      <LoadingWrapper show={advSearchState.actionLoader} position="fixed" />
    </div>
  );
});

const CompanySearch = observer(props => {
  Utils.stopBodyScroll();

  return (
    <>
      <CompanySearchWrap {...props} />
    </>
  );
});

export default withRouter(CompanySearch);
